import { useGetObservedDataOptionsQuery } from 'services/api/Meteorology/Fields/ObservedData';
import { ResponseError } from 'services/api/base';
import useHandleRequestErrors from '../useHandleRequestErrors';

export default function useObservedDataOptions() {
  const { data, error, isLoading } = useGetObservedDataOptionsQuery();

  useHandleRequestErrors(error as ResponseError);

  return { options: data, optionsLoading: isLoading };
}
